import { Avatar, Button, Divider, Dropdown, List, Menu, message, Radio, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { CheckCircle, ClipboardList, ClipboardPen, LogOut, NotebookPen, Plus, Send, User2 } from 'lucide-react';
import { fetchProfile } from '../../service/api';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';



function StaffProfileMenu() {
       
    const { logoutStaffParent, user, getCurrentUser ,userType} = useAuth()
    const { email, role, personalInformation } = user || {}
    const [open, setOpen] = useState(false); 
    const navigate=useNavigate()

    const handleLogout = () => {
        logoutStaffParent()
        setOpen(false)
    }


    const getCurrentProfile = async () => {
        try {
            const res = await fetchProfile()
            console.log("fetch staff user", res)
            if (res.status === 200) {
                const fetchData = res.data.data
                getCurrentUser(fetchData)
                setOpen(false)
            }
        } catch (error) {
            console.log(error)

        }
    }

    useEffect(() => {
        getCurrentProfile()
    }, [])

    const menu = (
        <Menu
            className="custom-profile-dropdown"
            items={[
                {
                    key: '1',
                    // disabled: true,
                    label: (
                        <>
                            <h2>My Account </h2>
                            <hr />
                            <List itemLayout="horizontal">
                                <List.Item >
                                    <List.Item.Meta
                                        avatar={personalInformation?.profileImage ? <Avatar size={45} src={personalInformation?.profileImage} />
                                            : <Avatar src={`https://api.dicebear.com/7.x/miniavs/svg`} />
                                        }
                                        title={<Link to="/staff/profile-details" style={{ textDecoration: "line" }}>{personalInformation?.fullName}</Link>}
                                        description={
                                            <div>
                                                <h5>{role}</h5>
                                                <p>{email}</p>
                                            </div>
                                        }
                                    />
                                </List.Item>
                            </List>
                            <Divider style={{ margin: "8px 0" }} />
                        </>
                    ),
                },

                {
                    key: '2',
                    label: (
                        <p onClick={() => navigate('/staff/aboutus')}><ClipboardList size={12} /> About us</p>
                    ),
                },
                {
                    key: '3',
                    label: (
                        <p onClick={() => navigate('/staff/privacy-policy')}><ClipboardPen size={12} /> Privacy Policy</p>
                    ),
                },
                {
                    key: '4',
                    label: (
                        <p onClick={() => navigate('/staff/term-condition')}><NotebookPen size={12} /> Terms & Conditions</p>
                    ),
                },
                {
                    key: '5',
                    label: (
                        <Button block onClick={handleLogout} danger icon={<LogOut size={16} />}>Logout</Button>
                    ),
                },

            ]}
        />
    );


    return (

        <div >
            <Space direction="vertical">
                <Dropdown
                    open={open}
                    onOpenChange={setOpen}
                    overlay={menu} placement="bottomRight" trigger={['click']}>
                    <Space style={{ cursor: "pointer" }}>
                        <h3> Welcome,🎉 {personalInformation?.fullName || "Guest"}  </h3>
                        {personalInformation?.profileImage ? <Avatar size={36} src={personalInformation?.profileImage} />
                            : <Avatar size={36} icon={<User2 size={20} />} />}
                    </Space>
                </Dropdown>
            </Space>
        </div>
    )
}



export default StaffProfileMenu